import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAvatarsCollection, getProfiles } from './redux/profile.actions';
import { SelectProfileView } from './components/SelectProfileView';
import { SET_IS_LOADING_PROFILES } from './redux/profile.types';
import { CreateProfileView } from './components/CreateProfileView';
import { SelectProfileImgView } from './components/SelectProfileImgView';
import { ManageProfilesView } from './components/ManageProfilesView';
import { EditProfileView } from './components/EditProfileView';
import { DeleteProfileView } from './components/DeleteProfileView';
import { useDisableScrollInModal } from './../../hooks/useDisableScrollInModal';
import './scss/profilesButtons.scss';
import './scss/profilesCommon.scss';
import './style.scss';
import { getUserToken } from 'utils/user/getUserToken';

export const ProfileManager = () => {
  const {
    avatars,
    profilesInfo,
    displayModal,
    isLoading,
    layout,
  } = useSelector(state => state.profilesManager);
  const user = useSelector(state => state.user);
  useDisableScrollInModal(displayModal);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user.token) return;
    (!avatars || !profilesInfo) &&
      dispatch({
        type: SET_IS_LOADING_PROFILES,
        payload: true,
      });

    !avatars && dispatch(getAvatarsCollection());
    !profilesInfo &&
      dispatch(
        getProfiles({
          user_token: getUserToken(),
          gamification_id: user.gamification_id,
        }),
      );
  }, []);

  const renderProfileView = useMemo(
    () => {
      switch (layout) {
        case 'SELECT_PROFILE':
          return <SelectProfileView />;
        case 'CREATE_PROFILE':
          return <CreateProfileView />;
        case 'SELECT_PROFILE_IMAGE':
          return <SelectProfileImgView />;
        case 'MANAGE_PROFILES':
          return <ManageProfilesView />;
        case 'EDIT_PROFILE':
          return <EditProfileView />;
        case 'DELETE_PROFILE':
          return <DeleteProfileView />;
        default:
          return <SelectProfileView />;
      }
    },
    [layout],
  );

  if (!displayModal || isLoading || profilesInfo === null) return null;

  return (
    <article className="profile-manager fade__in">{renderProfileView}</article>
  );
};
